module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BusinessCardView.js"));
	}, "BusinessCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BusinessCardView!./src/pages/Promote/BusinessCard/BusinessCardView.js
// module id = 2057
// module chunks = 367